export const allowedPaths = {
  athlete: [
    "/dashboard",
    "/dashboard/programmingcalendar",
    "/dashboard/messages",
    "/dashboard/congratulations/:id",
    "/dashboard/messages",
    "/trackjoiningpage",
    "/successpage"
  ],
  owner: [
    "/dashboard",
    "/dashboard/programmingcalendar",
    "/dashboard/messages",
    "/dashboard/manageathletes",
    "/dashboard/manageathletes/athletedetails/:athleteId",
    "/dashboard/subscribe",
    "/dashboard/connect",
    "/dashboard/congratulations/:id",
    "/dashboard/messages",
  ],
};
